<template>
  <div>
    <div class="form-list">
      <div class="form-header">일반</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="X / Y">
          <el-input-number v-model="formModel.x" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.y" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="가로 / 세로">
          <el-input-number v-model="formModel.width" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.height" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="회전">
          <el-input-number v-model="formModel.r" :precision="0" controls-position="right" :style="fullField"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-list">
      <div class="form-header">채우기</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="색상">
          <w-color-field v-model="formModel.fillOptions.color" :style="fullField"></w-color-field>
        </el-form-item>
        <el-form-item label="투명도">
          <el-input-number v-model="formModel.fillOptions.alpha" controls-position="right" :min="0" :max="1" :step="0.1" :style="fullField"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-list">
      <div class="form-header">테두리</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="색상">
          <w-color-field v-model="formModel.strokeOptions.color" :style="fullField"></w-color-field>
        </el-form-item>
        <el-form-item label="투명도">
          <el-input-number v-model="formModel.strokeOptions.alpha" controls-position="right" :min="0" :max="1" :step="0.1" :style="fullField"></el-input-number>
        </el-form-item>
        <el-form-item label="두께">
          <el-input-number v-model="formModel.strokeOptions.weight" controls-position="right" :min="0" :style="fullField"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import WColorField from '@/components/form/ColorField';

import ObjectProperty from '@/mixins/topologymap/object-property';

export default {
  name: 'WShapeProperty',
  components: {
    WColorField,
  },
  mixins: [ObjectProperty],
  data() {
    return {};
  },
};
</script>
<style module>
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/ShapeProperty.vue